import { User } from "./user.model";

export class BaseModel {
  Id: number = -1;
}  

export class CreatableBaseModel extends BaseModel {
  CreatedDateUTC?: Date | null;
  CreatedBy?: number;
  CreatedByUser?: User | null;
}

export class ModifiableBaseModel extends CreatableBaseModel {
  ModifiedDateUTC?: Date | null;
  ModifiedBy?: number | null;
  ModifiedByUser?: User | null;
}

export class DeletableBaseModel extends ModifiableBaseModel {
  IsDeleted?: boolean;
  DeletedDateUTC?: Date | null;
  DeletedBy?: number | null;
  DeletedByUser?: User | null;
}  
